import '../../utils/index2.mjs';
import Icon from './src/icon4.mjs';
export { iconProps } from './src/icon3.mjs';
import { withInstall } from '../../utils/vue/install2.mjs';

const ElIcon = withInstall(Icon);

export { ElIcon, ElIcon as default };
//# sourceMappingURL=index2.mjs.map
